import { PontuacaoBeneficio } from './pontuacao-beneficio';

export class Pontuacao {
    public id: number;
    public codigoEstudoSocioEconomico: number;
    public pontuacaoGeral: number;
    public pontuacaoMoradia: number;
    public pontuacaoCreche: number;
    public rendaPerCapta: number;
    public percentualPerCapta: number;
    public pontuacaoQuestionario: number;
    public parecer: string;
    public dataInclusao: Date;
    public dataEncerramento: Date;
    public justificativaEncerramento: string;


    public detalhesRendaPerCapta: string;
    public detalhesPontuacaoPerCapta: string;
    public detalhesPontuacaoGeral: string;
    public detalhesMoradia: string;
    public detalhesCreche: string;
    public detalhesPontuacaoQuestionario: string;


    public idUsuario: number;
    public nomeUsuario: string;
    public beneficios: PontuacaoBeneficio[];
}

